<template>
    <networks-provider v-slot="{ handleCompleteConnection }" style="height: 100%">
        <connect-network-failed-view
            @go-to-source="handleCompleteConnection"
        />
    </networks-provider>
</template>

<script>
    import ConnectNetworkFailedView from "../data-views/networks/ConnectNetworkFailedView";
    import NetworksProvider from "../providers/proposal-steps/NetworksProvider";
    export default {
        name: "CampaignConnectNetworkFailedRouterView",
        components: {NetworksProvider, ConnectNetworkFailedView}
    }
</script>
